/**
 * Builders to make it a little easier to pass "helperText" and "intent" properties to FormGroups.
 *
 * Usually, you end up passing both at the same time.
 *
 * Using these as "property mixins" on a FormGroup lets you combine logic into a fallback chain:
 *
 * <FormGroup
 *      label=""
 *      {...(
 *          dependentFieldNotLoaded ? danger("Select this other thing first") :
 *          noItemsSelected ? warning("You know this isn't filled in, right?") :
 *          undefined
 *      )}
 * />
 */

// import { IFormGroupProps, Intent } from '@blueprintjs/core';
import { ReactNode } from 'react';
export { ValidationMapOf } from './types';

export function info(helperText: string): Pick<any, 'helperText'> {
    return { helperText };
}

export function warning(helperText: string): Pick<any, 'helperText' | 'intent'> {
    return { helperText, intent: 'warning' };
}

export function danger(helperText: ReactNode): { helperText: ReactNode; intent: 'danger' } {
    return { helperText, intent: 'danger' };
}
